export default {"src":"/_next/static/media/frozenyogurt.be2e5813.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};